import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { DiReact, DiNodejs, DiMongodb } from "react-icons/di";
import { AiOutlineMail } from "react-icons/ai";
import {
  SiNextdotjs, SiTypescript, SiPostgresql, SiDocker,
  SiRedux, SiTailwindcss, SiGraphql, SiRedis,
  SiExpress, SiGithubactions, SiJest,
} from "react-icons/si";
import { FaAws } from "react-icons/fa";

const SKILL_CATEGORIES = [
  {
    category: "Frontend",
    skills: [
      { label: "React.js",    icon: <DiReact />,        color: "#61DAFB" },
      { label: "Next.js",     icon: <SiNextdotjs />,    color: "#ffffff" },
      { label: "TypeScript",  icon: <SiTypescript />,   color: "#3178C6" },
      { label: "Redux",       icon: <SiRedux />,        color: "#764ABC" },
      { label: "Tailwind CSS",icon: <SiTailwindcss />,  color: "#38BDF8" },
    ],
  },
  {
    category: "Backend",
    skills: [
      { label: "Node.js",     icon: <DiNodejs />,       color: "#68A063" },
      { label: "Express.js",  icon: <SiExpress />,      color: "#ffffff" },
      { label: "GraphQL",     icon: <SiGraphql />,      color: "#E10098" },
    ],
  },
  {
    category: "Database & Cache",
    skills: [
      { label: "PostgreSQL",  icon: <SiPostgresql />,   color: "#336791" },
      { label: "MongoDB",     icon: <DiMongodb />,      color: "#4DB33D" },
      { label: "Redis",       icon: <SiRedis />,        color: "#DC382D" },
    ],
  },
  {
    category: "Cloud & DevOps",
    skills: [
      { label: "AWS",         icon: <FaAws />,          color: "#FF9900" },
      { label: "Docker",      icon: <SiDocker />,       color: "#2496ED" },
      { label: "GitHub Actions", icon: <SiGithubactions />, color: "#2088FF" },
      { label: "Jest",        icon: <SiJest />,         color: "#C21325" },
    ],
  },
];

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center">
            <Col xs={12} md={7} className="home-header">
              <h1 className="heading animate-fadeInUp" style={{ paddingBottom: 15 }}>
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name animate-fadeInUp-delay">
                I'M
                <strong className="main-name"> CHANDRAPRAKASH KUSHWAHA</strong>
              </h1>

              <div className="type-wrapper animate-fadeInUp-delay2">
                <Type />
              </div>

              <div className="home-cta-buttons animate-fadeInUp-delay3">
                <Button
                  as={Link}
                  to="/project"
                  className="home-cta-btn primary-cta-btn"
                >
                  View My Work
                </Button>
                <Button
                  as={Link}
                  to="/about"
                  className="home-cta-btn secondary-cta-btn"
                >
                  About Me
                </Button>
                <Button
                  as={Link}
                  to="/contact"
                  className="home-cta-btn connect-cta-btn"
                >
                  <AiOutlineMail style={{ marginRight: 6, verticalAlign: "middle" }} />
                  Let's Connect
                </Button>
              </div>

              <div className="skill-categories animate-fadeInUp-delay3">
                {SKILL_CATEGORIES.map(({ category, skills }) => (
                  <div key={category} className="skill-category-row">
                    <span className="skill-category-label">{category}</span>
                    <div className="skill-badges">
                      {skills.map(({ label, icon, color }) => (
                        <span
                          key={label}
                          className="tech-badge"
                          style={{ "--badge-color": color }}
                          title={label}
                        >
                          <span className="tech-badge-icon" style={{ color }}>{icon}</span>
                          {label}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </Col>

            <Col xs={12} md={5} className="home-img-col">
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid home-logo-float"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
